import axios from 'axios';
import { supabase } from '../config/supabase';

interface StepData {
  id: string;
  step: number;
  instructions: string;
  thumbnail: string;
  video: File | null;
  mediaType: 'thumbnail' | 'video' | 'none';
  muxAssetId?: string;
  muxPlaybackId?: string;
  uploadStatus?: 'pending' | 'uploading' | 'completed' | 'error';
  uploadError?: string;
  useRecipeImage?: boolean;
}

export const saveRecipeSteps = async (recipeId: string, steps: StepData[], recipeImageUrl?: string) => {
  try {
    // First, delete all existing steps for this recipe
    const { error: deleteError } = await supabase
      .from('RecipeSteps')
      .delete()
      .eq('RecipeID', recipeId);

    if (deleteError) throw deleteError;

    // Then insert the new steps
    if (steps.length > 0) {
      const { data, error } = await supabase
        .from('RecipeSteps')
        .insert(
          steps.map(step => {
            // Determine what to save for the thumbnail
            let thumbnailToSave = step.thumbnail;
            let muxAssetIdToSave = step.muxAssetId;
            let muxPlaybackIdToSave = step.muxPlaybackId;
            
            // If user selected image but didn't upload, or selected video but didn't upload, 
            // or didn't select any media type, we'll use recipe image
            if ((step.mediaType === 'thumbnail' && !step.thumbnail) || 
                (step.mediaType === 'video' && !step.muxAssetId) ||
                step.mediaType === 'none') {
              thumbnailToSave = recipeImageUrl || ''; // Use recipe image as fallback
              muxAssetIdToSave = undefined;
              muxPlaybackIdToSave = undefined;
            }
            
            // For videos, if we have a Mux thumbnail, use it as the thumbnail
            if (step.mediaType === 'video' && step.muxPlaybackId && step.thumbnail) {
              thumbnailToSave = step.thumbnail; // This will be the Mux thumbnail URL
            }
            
            return {
              RecipeID: recipeId,
              Step: step.step,
              Instructions: step.instructions,
              Thumbnail: thumbnailToSave,
              MuxAssetId: muxAssetIdToSave,
              MuxPlaybackId: muxPlaybackIdToSave,
              upload_error: step.uploadError || null
            };
          })
        );

      if (error) throw error;
      return data;
    }

    return [];
  } catch (error) {
    console.error('Error saving recipe steps:', error);
    throw error;
  }
}; 